import { render, staticRenderFns } from "./CardChartCompare.vue?vue&type=template&id=ddf23410&scoped=true&"
import script from "./CardChartCompare.vue?vue&type=script&lang=js&"
export * from "./CardChartCompare.vue?vue&type=script&lang=js&"
import style0 from "./CardChartCompare.vue?vue&type=style&index=0&id=ddf23410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf23410",
  null
  
)

export default component.exports